import React, { useRef, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Appointments from "./components/Appointments";
import Blog from "./components/Blog";
import BlogDetail from "./components/BlogDetail";
import BlogForm from "./components/BlogForm";
import { fetchCsrfToken } from "./apis/Interceptor";
import { ToastContainer } from "react-toastify";
import RedirectHome from "./components/RedirectHome";
import ErrorPage from "./common/ErrorPage";
import Slot from "./components/Slot";
import SlotForm from "./components/SlotForm";

function App() {
  const csrfFetchedRef = useRef(false);
  useEffect(() => {
    if (!csrfFetchedRef.current) {
      fetchCsrfToken();
      csrfFetchedRef.current = true;
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          <Route path="/" element={<RedirectHome />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <PrivateRoute roles={["admin"]}>
                <Appointments />
              </PrivateRoute>
            }
          />
          <Route
            path="/slots"
            element={
              <PrivateRoute roles={["admin"]}>
                <Slot />
              </PrivateRoute>
            }
          />
          <Route
            path="/slots/new"
            element={
              <PrivateRoute roles={["admin"]}>
                <SlotForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/slots/edit/:day"
            element={
              <PrivateRoute roles={["admin"]}>
                <SlotForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/blogs"
            element={
              <PrivateRoute>
                <Blog />
              </PrivateRoute>
            }
          />
          <Route
            path="/blogs/new"
            element={
              <PrivateRoute>
                <BlogForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/blogs/:id"
            element={
              <PrivateRoute>
                <BlogDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/blogs/edit/:id"
            element={
              <PrivateRoute>
                <BlogForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/specialities"
            element={
              <PrivateRoute>
                <div>Specialities Page</div>
              </PrivateRoute>
            }
          />
          <Route
            path="/queries"
            element={
              <PrivateRoute>
                <div>Queries Page</div>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
